import { Component, OnInit } from "@angular/core";
import { UserService } from "../../services/user/user.service";
import { User } from "../../interfaces/user";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { MzToastService } from "ng2-materialize";

@Component({
  selector: "app-user-profile",
  templateUrl: "./user-profile.component.html",
  styleUrls: ["./user-profile.component.scss"],
})
export class UserProfileComponent implements OnInit {
  user: User = { password: "" } as User;
  form: FormGroup;
  passwordForm: FormGroup;
  oldPassword = "" as string;
  newPassword = "" as string;
  confirmPassword = "" as string;
  error: string;
  passError: string;
  loading = true;

  constructor(
    private userService: UserService,
    private toastService: MzToastService
  ) {}

  errorMessages = {
    email: {
      required: "Bitte gib eine gültige E-Mail-Adresse an.",
      pattern: "Das E-Mail-Format ist ungültig.",
    },
    firstName: {
      required: "Bitte gib Deinen Vornamen an.",
      pattern: "Bitte gib Deinen Vornamen an.",
    },
    lastName: {
      required: "Bitte gib Deinen Nachnamen an.",
      pattern: "Bitte gib Deinen Nachnamen an.",
    },
    oldPassword: {
      required: "Bitte gib dein Passwort an.",
      pattern: "Das Passwort ist ungültig.",
      validateEqual: "",
    },
    newPassword: {
      required: "Bitte gib ein Passwort an.",
      pattern: "Das Passwort muss mindestens 6 Zeichen lang sein.",
      validateEqual: "Die Passwörter müssen übereinstimmen.",
    },
    confirmPassword: {
      required: "Bitte gib ein Passwort an.",
      pattern: "Das Passwort muss mindestens 6 Zeichen lang sein.",
      validateEqual: "Die Passwörter müssen übereinstimmen.",
    },
  };

  ngOnInit() {
    this.getUser();
    this.initForm();
    setTimeout(Materialize.updateTextFields, 10);
  }

  private initForm() {
    this.form = new FormGroup({
      email: new FormControl(
        { value: this.user.email, disabled: true },
        Validators.required
      ),
      firstName: new FormControl(this.user.firstName, Validators.required),
      lastName: new FormControl(this.user.lastName, Validators.required),
    });

    this.passwordForm = new FormGroup({
      oldPassword: new FormControl(this.oldPassword, Validators.required),
      newPassword: new FormControl(this.newPassword, Validators.required),
      confirmPassword: new FormControl(
        this.confirmPassword,
        Validators.required
      ),
    });
  }

  getUser() {
    this.loading = true;
    this.userService.getUser().then((user: User) => {
      this.loading = false;
      this.user = user;
    });
  }

  updateUser() {
    this.loading = true;
    this.user.firstName = this.user.firstName.trim();
    this.user.lastName = this.user.lastName.trim();
    this.userService
      .updateUser(this.user)
      .then((response) => {
        this.loading = false;
        this.toastService.show("Name gespeichert!", 4000, "confirm-toast");
      })
      .catch((error) => {
        this.loading = false;
        this.error = error.error.message;
      });
  }

  changePassword() {
    this.passError = null;
    if (this.passwordForm.valid) {
      this.loading = true;
      this.userService
        .changePassword(this.user._id, {
          oldPassword: this.oldPassword,
          newPassword: this.newPassword,
        })
        .then((response) => {
          this.loading = false;
          this.toastService.show(
            "Passwort gespeichert!",
            4000,
            "confirm-toast"
          );
          this.passwordForm.controls["oldPassword"].setValue("");
          this.passwordForm.controls["newPassword"].setValue("");
          this.passwordForm.controls["confirmPassword"].setValue("");
        })
        .catch((error) => {
          this.loading = false;
          if (error.error.message === "Wrong Password") {
            this.passError = "Das Passwort ist ungültig.";
          } else {
            this.passError = error.error.message;
          }
        });
    } else {
      var controlKey = Object.keys(this.passwordForm.controls).filter(
        (x) => this.passwordForm.controls[x].errors
      )[0];
      this.passError = this.errorMessages[controlKey][
        Object.keys(this.passwordForm.controls[controlKey].errors)[0]
      ];
    }
  }
}



// WEBPACK FOOTER //
// /agir/src/app/components/user-profile/user-profile.component.ts